import { isItemHeldByConversationItemParts, isItemHeldByItemReadingPane, } from './tryRemoveFromMailStoreItemsMutator';
import tryRemoveItemNormalizedBody from 'owa-mail-actions/lib/table-loading/tryRemoveItemNormalizedBody';
import { mutator } from 'satcheljs';
export default mutator(tryRemoveItemNormalizedBody, function (actionMessage) {
    var item = actionMessage.item;
    if (isItemHeldByConversationItemParts(item.ConversationId.Id, 0 /* ListViewTable */) ||
        isItemHeldByItemReadingPane(item.ItemId.Id, 0 /* ListViewTable */)) {
        // The item reference is currently held, we cannot remove normalized body at this time
        // We don’t need to check listview reference because this is only a listview scenario, i.e reload
        // where we need to remove the NormalizedBody from item
        return;
    }
    // Delete the normalizedBody of the item
    item.NormalizedBody = undefined;
});
//# sourceMappingURL=tryRemoveItemNormalizedBodyMutator.js.map